<i class="_icon inline-flex"
   [ngClass]="isBusy ? 'icon-loading' : 'icon-' + icon"></i>
@if(textAnimated) {
<p class="_text">
    <span class="p2 no-wrap">
        {{textAnimated}}
    </span>
</p>
}
